export default [
  {
    label: 'ユーザー会員登録・ログイン',
    value: 1,
  },
  {
    label: 'キャンプ場の新規登録依頼',
    value: 2,
  },
  {
    label: 'キャンプ場の情報・写真登録',
    value: 3,
  },
  {
    label: 'キャンプ場の閉店申請',
    value: 4,
  },
  {
    label: 'キャンプ場名称・住所の編集依頼',
    value: 5,
  },
  {
    label: '問題のあるレビューの報告',
    value: 6,
  },
  {
    label: 'マイページ・アカウントについて',
    value: 7,
  },
  {
    label: 'その他',
    value: 8,
  },
];
